import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const uploadCalanderFile = (classId, fileExtension, data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.UPLOAD_CALANDER_FILE(classId, fileExtension),
    data
  );
};

export default uploadCalanderFile;
